import { useUserContext } from '@/components/Auth/UserContext';
import { useMemo } from 'react';

export type UserTitles = {
  titreFr: string;
  titreEn: string;
};

export const DEFAULT_TITLES: UserTitles = {
  titreFr: 'Dr.',
  titreEn: 'MD',
};

export const useUserTitle = (_chirurgienId?: string) => {
  const { user, userIsLoading } = useUserContext();

  const titles = useMemo<UserTitles>(
    () => ({
      titreFr: user?.titreFr?.length ? user.titreFr : DEFAULT_TITLES.titreFr,
      titreEn: user?.titreEn?.length ? user.titreEn : DEFAULT_TITLES.titreEn,
    }),
    [user?.titreFr, user?.titreEn]
  );

  return {
    titles,
    loaded: !userIsLoading,
  };
};

export const getTitleForLanguage = (titles: UserTitles, language: string): string => {
  return language === 'fr' ? titles.titreFr : titles.titreEn;
};
